const listDisease = {
  allergies: {
    cat: '$255 (per year)',
    dog: '$350 (per year)',
    name: 'Allergies',
  },
  arthritis: {
    cat: '$500 (per year)',
    dog: '$700 (per year)',
    name: 'Arthritis',
  },
  bladderInfectionUti: {
    cat: '$1100',
    dog: '$400',
    name: 'Bladder infection',
  },
  brokenBone: {
    cat: '$2300',
    dog: '$2700',
    name: 'Broken bone',
  },
  cancer: {
    cat: '$3800 (per year)',
    dog: '$4100 (per year)',
    name: 'Cancer',
  },
  dentalDisease: {
    cat: '$800',
    dog: '$600',
    name: 'Dental disease',
  },
  diabetes: {
    cat: '$1900 (per year)',
    dog: '$2700 (per year)',
    name: 'Diabetes',
  },
  eyeConditions: {
    cat: '$260 (per year)',
    dog: '$300 (per year)',
    name: 'Eye conditions',
  },
  felineKidneyDisease: {
    cat: '$1300 (per year)',
    name: 'Feline kidney disease',
  },
  heartMurmur: {
    cat: '$1400',
    dog: '$1200',
    name: 'Heart murmur',
  },
  ingestedForeignObjects: {
    cat: '$3400',
    dog: '$3500',
    name: 'Ingested foreign objects',
  },
}

export default function () {
  const costCalculator = document.querySelector(
    '.PageMain--category-landing .CareCredit .CareCredit__cost-calculator'
  )

  if (!costCalculator) {
    return
  }

  const sections = Array.from(
    costCalculator.querySelectorAll('.CareCredit__cost-calculator-section')
  )
  const links = Array.from(
    costCalculator.querySelectorAll(
      '.CareCredit__cost-calculator-section .wp-block-button .wp-block-button__link'
    )
  )
  const diseaseName = costCalculator.querySelector(
    '.CareCredit____cost-calculator-disease-name mark'
  )
  const diseasePrice = costCalculator.querySelector(
    '.CareCredit____cost-calculator-disease-price mark'
  )
  const optionPetType = costCalculator.querySelector(
    '.CareCredit__cost-calculator-option-pet-type'
  )
  const optionHealthNeed = costCalculator.querySelector(
    '.CareCredit__cost-calculator-option-health-need'
  )

  if (
    !sections ||
    !links ||
    !diseaseName ||
    !diseasePrice ||
    !optionPetType ||
    !optionHealthNeed
  ) {
    return
  }

  const inputsPetType = Array.from(
    costCalculator.querySelectorAll(
      '.CareCredit__cost-calculator-option-pet-type input[name="careCreditCostCalculatorPetType"]'
    )
  )
  const selectHealthNeed = costCalculator.querySelector(
    '.CareCredit__cost-calculator-option-health-need-select'
  )
  const itemSelectedHealthNeed = costCalculator.querySelector(
    '.CareCredit__cost-calculator-option-health-need-select div'
  )
  const ulHealthNeed = costCalculator.querySelector(
    '.CareCredit__cost-calculator-option-health-need-select ul'
  )
  const emptyLiHealthNeed = costCalculator.querySelector(
    '.CareCredit__cost-calculator-option-health-need-select ul li'
  )

  if (
    !inputsPetType ||
    !selectHealthNeed ||
    !itemSelectedHealthNeed ||
    !ulHealthNeed ||
    !emptyLiHealthNeed
  ) {
    return
  }

  itemSelectedHealthNeed.addEventListener('click', function () {
    selectHealthNeed.classList.toggle('open')
  })

  emptyLiHealthNeed.addEventListener('click', function () {
    updateSelectedHealthNeed(itemSelectedHealthNeed, selectHealthNeed, this)
  })

  inputsPetType.forEach((input) => {
    input.addEventListener('change', function () {
      selectHealthNeed.classList.remove('open')

      // remove all li
      removeAllChildNodes(ulHealthNeed)

      // create new li's
      createNewItemHealthNeed(
        ulHealthNeed,
        'Select',
        '',
        true,
        'cost-calculator-health-need-select-option-empty',
        selectHealthNeed,
        itemSelectedHealthNeed
      )

      Object.keys(listDisease).forEach((disease) => {
        if (listDisease[disease].hasOwnProperty(this.value)) {
          createNewItemHealthNeed(
            ulHealthNeed,
            listDisease[disease].name,
            disease,
            false,
            `cost-calculator-health-need-select-option-${disease}`,
            selectHealthNeed,
            itemSelectedHealthNeed
          )
        }
      })

      // clean
      itemSelectedHealthNeed.textContent = 'Select'
      itemSelectedHealthNeed.dataset.value = ''
    })
  })

  links.forEach((link) => {
    link.addEventListener('click', function (e) {
      const elementHash = this.hash ? document.querySelector(this.hash) : null

      if (elementHash) {
        e.preventDefault()

        if (
          this.parentNode.classList.contains(
            'CareCredit__cost-calculator-calculate'
          )
        ) {
          if (
            !calculateHealthNeedValue(
              costCalculator,
              itemSelectedHealthNeed,
              optionPetType,
              optionHealthNeed,
              diseaseName,
              diseasePrice
            )
          ) {
            return
          }

          // remove all li
          removeAllChildNodes(ulHealthNeed)

          // create new li
          createNewItemHealthNeed(
            ulHealthNeed,
            'Select pet type',
            '',
            true,
            'cost-calculator-health-need-select-option-empty',
            selectHealthNeed,
            itemSelectedHealthNeed
          )
        }

        sections.forEach((section) => {
          section.classList.remove('active')
        })

        elementHash.classList.add('active')
      }
    })
  })
}

function calculateHealthNeedValue(
  costCalculator,
  itemSelectedHealthNeed,
  optionPetType,
  optionHealthNeed,
  diseaseName,
  diseasePrice
) {
  const inputPetType = costCalculator.querySelector(
    'input[name="careCreditCostCalculatorPetType"]:checked'
  )
  const petType = inputPetType?.value || ''
  const healthNeed = itemSelectedHealthNeed.dataset?.value || ''

  if (!petType) {
    optionPetType.classList.add('error')
  } else {
    optionPetType.classList.remove('error')
  }

  if (!healthNeed) {
    optionHealthNeed.classList.add('error')
  } else {
    optionHealthNeed.classList.remove('error')
  }

  if (!petType || !healthNeed) {
    return false
  }

  const value = getDiseaseValue(petType, healthNeed)

  if (!value) {
    optionHealthNeed.classList.add('error')
    return false
  } else {
    optionHealthNeed.classList.remove('error')
  }

  diseaseName.textContent = itemSelectedHealthNeed.textContent
  diseasePrice.textContent = value

  // clean
  itemSelectedHealthNeed.textContent = 'Select pet type'
  itemSelectedHealthNeed.dataset.value = ''
  inputPetType.checked = false

  return true
}

function createNewItemHealthNeed(
  container,
  text,
  value,
  selected,
  id,
  selectHealthNeed,
  itemSelectedHealthNeed
) {
  const newItem = document.createElement('li')
  newItem.textContent = text
  newItem.dataset.value = value
  newItem.role = 'option'
  newItem.ariaSelected = selected
  newItem.id = id
  newItem.addEventListener('click', function () {
    updateSelectedHealthNeed(itemSelectedHealthNeed, selectHealthNeed, this)
  })
  container.appendChild(newItem)
}

function updateSelectedHealthNeed(
  itemSelectedHealthNeed,
  selectHealthNeed,
  itemClicked
) {
  const allItems = Array.from(selectHealthNeed.querySelectorAll('ul li'))
  allItems.forEach((item) => {
    item.ariaSelected = false
  })

  itemClicked.ariaSelected = true
  itemClicked.parentNode.setAttribute('aria-activedescendant', itemClicked.id)
  itemSelectedHealthNeed.textContent = itemClicked.textContent
  itemSelectedHealthNeed.dataset.value = itemClicked.dataset?.value || ''
  selectHealthNeed.classList.remove('open')
}

function removeAllChildNodes(container) {
  container.innerHTML = ''
  container.removeAttribute('aria-activedescendant')
}

function getDiseaseValue(petType, healthNeed) {
  if (!petType || !healthNeed) {
    return 0
  }

  if (listDisease[healthNeed] && listDisease[healthNeed][petType]) {
    return listDisease[healthNeed][petType]
  }

  return 0
}
